/*
 * Copyright (c) 2024 Amazon.com, Inc. All Rights Reserved.
 */

/**
 * @author stcatai Jun 04, 2024
 */
import { Region } from "./Region";

export const MODEL_MARKETPLACE = new Map<Region, string>([
  [Region.NA, "USAmazon"],
  [Region.EU, "EUAmazon"],
  [Region.FE, "FEAmazon"],
  [Region.CN, "CNAmazon"]
]);